(function () {
  if (sessionStorage.getItem('addToCartTracked')) return;

  document.addEventListener('click', function (e) {
    const button = e.target.closest('button[data-add-to-cart]');
    if (!button) return;

    sessionStorage.setItem('addToCartTracked', 'true');

    setTimeout(function () {
      const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const variantId = variantInput ? parseInt(variantInput.value, 10) : null;

      if (window.ShopifyAnalytics?.lib?.track) {
        ShopifyAnalytics.lib.track('Added to Cart', {
          currency: Shopify.currency?.active || 'AUD',
          value: 1,
          variant_id: variantId
        });
        console.log('✅ ShopifyAnalytics.lib.track fired with variant ID:', variantId);
      } else {
        console.warn('⚠️ ShopifyAnalytics.lib.track not available — retrying in 1s');
        setTimeout(arguments.callee, 1000); // retry once more after 1s
      }
    }, 500);
  });
})();